import { Typography } from '@la/ds-ui-components';
import { PageBanner } from 'components/PageBanner/PageBanner';
import styles from './AddRosterWarningBanner.module.scss';

export const AddRosterWarningBanner = ({
  type,
}: {
  type: 'player' | 'staff member';
}) => {
  return (
    <div className={styles.container}>
      <PageBanner bannerType="warning" isClosable={false}>
        <Typography variant="ui" size="large">
          <strong>
            Heads up! Adding a {type} will not automatically invite them.
          </strong>{' '}
          Share the link below so they can officially join the roster.
        </Typography>
      </PageBanner>
    </div>
  );
};
